export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api/v1';

/** Télécharge un CSV depuis une route protégée */
export const downloadCsv = async (path, filename) => {
    const token = sessionStorage.getItem('admin_token');
    const res = await fetch(`${API_BASE}${path}`, {
        headers: { Authorization: token ? `Bearer ${token}` : '' },
    });
    if (res.status === 401) {
        sessionStorage.removeItem('admin_token');
        window.location.href = '/login';
        throw new Error('Session expirée');
    }
    if (!res.ok) throw new Error(`Erreur ${res.status}`);
    const blob = await res.blob();
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement('a');
    a.href = url; a.download = filename; a.click();
    URL.revokeObjectURL(url);
};

export const apiFetch = async (path, options = {}) => {
    const token = sessionStorage.getItem('admin_token');
    const headers = {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...(options.headers || {}),
    };
    const res = await fetch(`${API_BASE}${path}`, { ...options, headers });
    if (res.status === 401) {
        sessionStorage.removeItem('admin_token');
        window.location.href = '/login';
        throw new Error('Session expirée');
    }
    if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new Error(body.message || `Erreur ${res.status}`);
    }
    return res.json();
};
